export default {
  "additionalQuestion": {
    "adultFemale": "女性",
    "adultMale": "男性",
    "answerQuestions": "以下の追加質問にお答えください。",
    "checkinTime": "チェックイン時間",
    "checkoutTime": "チェックアウト時間",
    "moreDetailed": "宿泊内容詳細",
    "notificationFromFacility": "施設からのお知らせ",
    "selectTime": "時間を選択",
    "view": "表示"
  },
  "base": {
    "account": "アカウント",
    "apply": "適用",
    "attachFile": "ファイルを添付する",
    "backTo": "{0}に戻る",
    "booking": "予約一覧",
    "browserWarning": "現在ご利用のブラウザは公式サポートが終了しております。最新のブラウザをインストールの上、再度お試しください。",
    "cancel": "キャンセル",
    "close": "閉じる",
    "confirm": "予約を確定する",
    "continue": "次へ",
    "collapse": "縮小する",
    "delete": "削除",
    "edit": "変更",
    "error": "申し訳ございません、システムエラーが発生しました。少し時間を空けてから、再度お試しください。",
    "error02": "申し訳ございません、処理中にエラーが発生しました。少し時間を空けてから、再度お試しください。",
    "errorPaymentMethod": "支払い方法が異なるため、ご予約プロセスを進めることが出来ません。複数のお部屋を予約する場合、同じお支払い方法をお選びいただくか、別々のご注文でお部屋をご予約ください。",
    "oldErrorCode": {
      "1403": "このアカウントは施設によって登録されていますが、パスワードをリセットする必要があります。サインインページに戻り、[パスワードをお忘れの方]を押してください。"
    },
    "errorCode": {
      "2401": "{currentPoint}ポイントのポイント残高です。{spendPoint}ポイントを使うことができません。",
      "3001": "タイムアウトエラーが発生しました。決済処理は行われておりません。",
      "3002": "決済処理に失敗しました。",
      "3003": "このカードはご利用できません。",
      "3004": "カード番号をご確認ください。",
      "3005": "有効期限をご確認ください。",
      "3006": "3Dセキュア認証に失敗しました。",
      "3007": "ご利用できないカードを入力されたか、カード番号に間違いがあります。",
      "3008": "3Dセキュア認証がキャンセルされました。",
      "3009": "複数回のリクエストを受けたので、3Dセキュア認証を中断しました。",
      "3011": "タイムアウトエラーが発生しました。決済処理は行われておりません。",
      "3202": "ポイント残高が取得できません。",
      "3203": "申し訳ございません、処理中にエラーが発生しました。少し時間を空けてから、再度お試しください。",
      "3204": "支払いプロセスが失敗しました。別のカードを使用するか、後で再試行してください。",
      "3205": "このカードはご利用できません。",
      "3504": "ポイントの返却ができませんでした。ポイント履歴を確認して下さい。"
    },
    "fileLimit80MB": "アップロードする画像は1枚あたり80MBが上限です",
    "upTo30FilesError": "添付ファイルの上限は30ファイルです",
    "upTo30Files": "最大30ファイル",
    "textLengthLimit": "255字以内ご使用できます。",
    "GDPR": "GDPRポリシー",
    "here": "こちら",
    "imageError": "画像の読み込みに失敗しました。",
    "join": "会員登録",
    "languages": {
      "en": "English",
      "ja": "日本語",
      "ko": "한국어",
      "zh_Hans": "簡体中文",
      "zh_Hant": "繁體中文"
    },
    "loading": "確認中...",
    "login": "ログイン",
    "logout": "ログアウト",
    "logoutMessage": "すでにログアウトしています。",
    "memberSignIn": "会員ログイン",
    "memberSignUp": "会員様初回Web登録",
    "next": "次へ",
    "notSelected": "未選択",
    "noData": "データなし",
    "optional": "任意",
    "pay": "支払い",
    "previous": "戻る",
    "previousPage": "前のページ",
    "privacyPolicy": "個人情報の取扱い",
    "readMore": "続きを読む",
    "readLess": "省略する",
    "recommended": "オススメ",
    "remove": "削除",
    "required": "必須",
    "requireMessage": "必須項目が空欄です。",
    "reservationStatuses": {
      "cancelled": "キャンセル済",
      "done": "予約完了"
    },
    "save": "保存",
    "signInUp": "ログイン/登録",
    "submit": "送信",
    "termError": "利用規約に合意してください。",
    "taxMessage": "2019年10月以降の宿泊については、10%消費税率ではなく、現在の8%消費税率前提での税抜価格が計算されて表示されております。大変お手数はございますが、10月以降のご予約については税抜金額ではなく、予約確認画面での税込価格をご確認ください。",
    "termsOfUse": "利用規約",
    "topPage": "トップページ",
    "update": "更新する",
    "warning": {
      "kidsChanged": "この施設ではご指定の検索条件に対応していないため、子供の検索条件が変更されました。"
    }
  },
  "bookingDetail": {
    "overlappedReservation": "現在ご予約中のチェックイン・チェックアウト日と重複する{0}があります。ご予約前に再度ご確認ください。\n※重複している予約は、同じチェーンの他施設からの予約の場合がございます。",
    "overlappedReservationLink": "ご予約",
    "overlappedReservationGuest": "現在ご予約中のチェックイン・チェックアウト日と重複するご予約があります。ご予約前に受信したメールを再度ご確認ください。\n※重複している予約は、同じチェーンの他施設からの予約の場合がございます。\n※他のデバイスで予約をキャンセルした場合は、この検出が間違っている可能性があります。受信したメールをご確認ください。",
    "overlappedReservationGuest2": "※他のデバイスで予約をキャンセルまたはCookieをクリアにした場合は、この検出が間違っている可能性があります。受信したメールをご確認ください。"
  },
  "bookingResult": {
    "allUser": "全ユーザー",
    "availableBetween": "対象期間",
    "bath": "風呂",
    "bedCount": "{n}台",
    "book": "予約する",
    "bookAirline": "航空券付で予約する",
    "cancellationFreeUntil": "{0}まで(現地時間) はキャンセル料がかかりません。",
    "cancellationPolicy": "キャンセルポリシー",
    "discountAmount": "割引額",
    "excludeDuring": "除外期間",
    "forNights": "{n}泊の料金",
    "freeWifi": "WiFi無料",
    "guests": "ご利用人数",
    "includes": "このプランには以下のものが含まれます",
    "planInformation": "このプランには以下のものが含まれます",
    "lowestPriceInfo": "在庫状況や割引条件により、最低価格がカレンダーに表示されない場合があります。実際の価格はカレンダーよりご確認ください。",
    "maxAdults": "大人は最大{n}名様までご利用いただけます",
    "meals": "食事",
    "memberExclusive": "会員限定",
    "membersOnly": "会員限定",
    "nonSmoking": "禁煙",
    "noRoomFound": "空室が見つかりませんでした。",
    "tryChanging": "{0}を変更のうえ、再検索してください。",
    "tryItem": "ご希望条件",
    "noRoomSelected": "部屋は未選択です",
    "notAvailable": "予約不可",
    "priceFor": "合計金額",
    "priceForAdult": "大人 × {n}名",
    "priceForChild": "子供 × {n}名",
    "priceForRoom": "部屋",
    "paymentCreditCard": "クレジットカードで事前決済",
    "paymentMethods": "支払い方法",
    "paymentMethod": {
      "on_site": "現地決済",
      "credit_card": "クレジットカードで事前決済",
      "on_site_credit_card_required": "現地決済（事前のクレジットカード登録が必要です）",
      "deferred_payment": "後払い",
      "credit_card_full": "クレジットカードでの全額支払い",
      "credit_card_deposit": "クレジットカードでのデポジット支払い",
      "bank_transfer": "銀行振込"
    },
    "paymentNewCreditCards": "クレジットカードで事前決済",
    "paymentRegisteredCreditCards": "登録しているクレジットカードで事前決済",
    "planDetails": "プラン詳細",
    "plansLimitForUpdating": "元々選択しているプランからは変更できません。",
    "price": "金額",
    "promotionMayChanged": "このプロモーションは予告なく、終了日より前に変更または終了する場合があります。",
    "registerCard": "カードを登録する",
    "regularRate": "通常価格",
    "reservationStartDate": "予約開始日",
    "showRoomDetails": "部屋の詳細を表示",
    "roomDetails": "お部屋の詳細",
    "roomFeatures": "お部屋の情報",
    "roomLeft": "残り{n}部屋！",
    "roomAvailable": "残り{n}部屋",
    "roomEnough": "空室あり",
    "roomRate": "料金",
    "rooms": "部屋数",
    "roomSize": "部屋サイズ",
    "roomSizeUnit": {
      "tatami_mats": "畳"
    },
    "select": "選択する",
    "selectNewDate": "別の日程で検索",
    "serviceFeeDesc": "この価格は宿泊予約サイトの各サービス料を含んだ額になります。",
    "sleeps": "利用人数",
    "smoking": "喫煙可",
    "stopReservationUpdate": "予約変更をやめる",
    "targetUser": "対象者",
    "taxExcluded": "税抜",
    "taxIncluded": "税込",
    "toilet": "トイレ",
    "totalPrice": "円",
    "totalPriceForNights": "{n}泊の合計料金 | {n}泊の合計料金 | {n}泊の合計料金",
    "viewAll": "全て表示",
    "viewClose": "閉じる",
    "viewGallery": "全ての写真を表示する",
    "viewLess": "元に戻す",
    "viewMore": "全てのプランを表示する ({n}件)",
    "viewAllRooms": "{n}部屋すべてを表示",
    "wifi": "WiFi",
    "wifiOption1": "なし",
    "wifiOption2": "無料",
    "wifiOption3": "有料",
    "searchResults": "検索結果:",
    "nPlans": "{n} 件",
    "nRoomTypes": "{n} 件"
  },
  "customAuth": {
    "failTitle": "ログインに失敗しました。",
    "failDesc": "会員情報が登録されていないので、ログインできません。"
  },
  "cancellationPolicy": {
    "policyHeader": "キャンセル料は下記のとおりです。",
    "policyLine": "宿泊日{0}日前　 料金の{1}％",
    "policyLineWithTime": "宿泊{0}日前 {1}以降 宿泊料の{2}％",
    "freePolicyLine": "宿泊日{0}日前　 キャンセル：無料",
    "noShowLine": "ご連絡なしの場合：料金の{0}％",
    "cancelOnTheDay": "宿泊当日 料金の{0}％",
    "cancelOnTheDayFree": "宿泊日当日前{0}まで  キャンセル：無料",
    "cancelOnTheDayCharge": "宿泊当日{0}以降　宿泊料の{1}％",
    "uponLocalTime": "*すべてのキャンセル ポリシーは、現地時間に基づいて計算されます。",
    "ifBookedElsewhere": "他社サイトや旅行会社経由のご予約のキャンセルについては、各サイト・旅行会社にお問合せください。",
    "specialRate": "特別キャンセルフィー: {0}",
    "guest": "お客様"
  },
  "calendar": {
    "fullyBooked": "満室",
    "roomsLeft": "残り10部屋未満",
    "selected": "ご宿泊予定日",
    "unavailable": "残室なし"
  },
  "corporateAdmin": {
    "admin": "管理者",
    "checkInDate": "チェックイン日",
    "download": "ダウンロード",
    "guestName": "宿泊者名",
    "hotelName": "ホテル名",
    "maxNumberStay": "最大宿泊数",
    "maxNumberStays": "最大宿泊数",
    "nMonths": "{n}ヶ月",
    "nights": "宿泊日数",
    "numberOfRooms": "部屋数",
    "remaining": "宿泊可能数",
    "reservationData": "予約情報",
    "reservationDataDesc1": "※ ご利用内訳は、当専用ホームページでご予約いただいた方の合計での宿泊数を表示しております。従いまして、これ以外の予約（電話等）分につきましては、反映されておりませんので、ご注意ください。",
    "reservationDataDesc2": "※ ご予約・ご宿泊いただいてから、その内容が当ページに反映されるまで、数分〜数十分の時間がかかることがあります。あらかじめご了承ください。",
    "reservationDataDesc3": "※ 当専用ホームページ以外でご依頼された宿泊内容の変更・キャンセルはこの画面には反映されておりません。",
    "reservationDate": "予約日",
    "reservationNumber": "予約番号",
    "reserved": "宿泊済数",
    "status": "ステータス",
    "title": "法人管理者",
    "totalPrice": "料金",
    "period": "期間",
    "year": "年"
  },
  "creditCardForm": {
    "addNewCard": "新しいクレジットカードを入力",
    "cardExpiration": "有効期限",
    "cardExpirationConfirm": "有効期限をご確認ください",
    "cardHolder": "カード名義",
    "cardHolderConfirm": "カード名義をご確認ください",
    "cardHolderFormatError": "名前は半角のローマ字で入力してください",
    "cardHolderHelp": "カードに印字されている名前をご記入ください",
    "cardNumber": "カード番号",
    "cardNumberConfirm": "カード番号をご確認ください",
    "cardNumberHelp": "カード番号をご記入ください",
    "cardRequired": "カード情報は予約確保を目的とし、直ちに課金されることはありません。キャンセル料が発生した場合のみ、{0}に従ってカードに課金されます。",
    "cardSecurityCode": "セキュリティコード",
    "cardSecurityCodeConfirm": "セキュリティコードをご確認ください",
    "cardSecurityCodeHelp": "CVV",
    "creditCard": "クレジットカード",
    "expiredError": "チェックアウト日まで有効なクレジットカードを登録してください。",
    "month": "月",
    "payInAdvance": "こちらのお支払方法は、{0}による手配・クレジットカードによる事前決済となります。",
    "payInAdvanceVoucher": "こちらのお支払方法は、{0}によるクレジットカード事前決済となります。",
    "tappayNote": "TapPay 2048-bit SLL トランザクションシステムを使用して、クレジットカード情報を保護します。カードの顧客情報は保存されません。 TapPayは、PCI DSSのサービスプロバイダーレベル1に準拠していると認定されています。",
    "year": "年",
    "cardBrand": "カードブランド",
    "cardBrandMismatch": "入力したカード番号が、選択したカードブランドと一致しません。セキュリティ上の理由から修正してください。ご不便をおかけして申し訳ございません。",
    "paymentOverMillionError": "100万円を超えるオンライン決済は、VISA, Masterカードではご利用いただけません。他のカードブランドをご利用いただくか、他の支払タイプを選択してください。",
    "badCards": "システム変更のため、以下のカードは新規のご予約にはご利用いただけません。お手数ですが、再度カード情報を入力してください。"
  },
  "gmoPaypalOptions": {
    "null": "カードブランドを選択してください",
    "visa": "VISA",
    "master": "Mastercard",
    "mastercard": "Mastercard",
    "amex": "American Express",
    "jcb": "JCB",
    "diners": "Diners Club"
  },
  "downloadPasswordModal": {
    "label": "暗号化のためのパスワードを入力してください。ダンロードしたzipファイルはこのパスワードで復元してください。"
  },
  "extraItems": {
    "error": {
      "extraNumber": "{name} の数を変更してください。予約可能な数は、{min}〜{max}です。"
    }
  },
  "facilitySuggestion": {
    "distanceFrom": "距離: この施設から{n}km",
    "from": "以下の最安値より",
    "header": "宿泊可能な近隣の施設",
    "soldOut": "空室が見つかりませんでした。ご希望条件を変更のうえ、再検索してください。",
    "soldOutDesc": "申し訳ございません。ご指定の条件ではご予約いただけるお部屋はございません",
    "visitHotelWebsite": "施設のウェブサイトを開く"
  },
  "guestDetail": {
    "afterUpdate": "変更後",
    "bookingForSomeone": "代理で予約している場合、宿泊者本人ではない場合はこちらをチェック",
    "brrDiscount": "最低価格保証割引",
    "confirmUpdates": "予約変更を確定",
    "confirmPayByCard": "クレジットカード支払いの確認",
    "coupon": "クーポン",
    "couponApplied": "{code}が適用されています。",
    "creansmaerdCouponApplied": "{name}が適用されています。",
    "couponCode": "クーポンコード",
    "couponDiscount": "クーポン割引",
    "couponExpired": "このクーポンコードは有効ではありません。",
    "couponInvalid": "入力されたクーポンコードが間違っています。",
    "couponLimitReached": "ご利用上限に達したため、このクーポン {code}はご利用いただけなくなりました。",
    "couponMaxStays": "このクーポンの割引は、最初の{n}泊までご利用いただけます。 {n}泊以降の宿泊は、通常料金が請求されます。",
    "couponTargetPlans": "クーポンコード適用対象プラン",
    "couponNotUse": "クーポンを利用しない",
    "couponValidUntil": "有効期限 {date}",
    "creditCardWarning": "当初の予約のクレジットカード決済はキャンセル/払い戻しとなり、予約変更後の価格で新規の決済となります。",
    "day": "{n}日目",
    "email": "メールアドレス ({email}指定受信の設定をお願いします)",
    "emailAgain": "メールアドレス(確認用)",
    "emailAgainConfirm": "確認用のメールアドレスが一致しません",
    "emailAgainHelp": "もう一度メールアドレスを入力してください",
    "emailConfirm": "正しいメールアドレスを入力してください",
    "emailHelp": "メールアドレスを入力してください",
    "extras": "オプション",
    "extraLeft": "残り{count} {unit}",
    "extraOutOfStock": "在庫なし",
    "fullName": "お名前（ひらがな）",
    "fullNameError": "お名前をひらがなで入力してください",
    "guestDetails": "お客様情報",
    "guestName": "宿泊者名",
    "guestNameError": "お名前はひらがな、または、アルファベットで入力してください",
    "guestNameHelp": "ご氏名を全てひらがなで入力してください",
    "guestNameKanji": "宿泊者名 (漢字)",
    "guestStayName": "宿泊者名",
    "mainGuest": "代表者の連絡先",
    "notes": "ご注意",
    "originalPaymentAmount": "元の予約のお支払い金額",
    "promotionDiscount": "割引",
    "phone": "電話番号",
    "phoneConfirm": "正しいお電話番号をご入力下さい",
    "phoneHelp": "電話番号を入力してください(半角数字)",
    "priceBecomeCheaper": "現在選択中のプランに適用されているプロモーションの内容が宿泊施設によって変更されたため、お値段がお安くなりました。現在の価格をご確認の上、予約を進めてください。",
    "priceBecomeExpensive": "申し訳ございませんが、現在選択中のプランに適用されているプロモーションの内容が宿泊施設によって変更されたため、お値段が高くなりました。現在の価格をご確認の上、予約を進めてください。",
    "priceDiff": "価格差異",
    "signupTerms": "本予約システムはtripla(株)により提供されており、お客様の個人情報はtripla(株)と共有されることを理解の上で、tripla{0}、{1}、および、{2}に同意の上、会員登録を行います。",
    "terms": "本予約システムはtripla(株)により提供されており、お客様の個人情報はtripla(株)と共有されることを理解の上で、本予約の完了をもって、tripla{0}、{1}、および、{2}に同意します。",
    "totalAmountWithTax": "合計金額（税込）",
    "totalWithoutTax": "合計金額（税抜）",
    "updateUserInformation": "上記の内容でWEB会員情報を更新する（メールアドレスを除く）"
  },
  "lineLogin": {
    "buttonText": "LINEでログイン"
  },
  "meta": {
    "facilities": "ブランド施設",
    "sign_in": "ログイン",
    "organization_sign_in": "法人ログイン",
    "sign_up": "会員登録",
    "search_results": "宿泊プラン一覧",
    "guest_detail": "お客様情報入力",
    "payment_method": "お支払い情報入力",
    "completed": "予約完了",
    "my_account": "マイページ"
  },
  "membership": {
    "promotionRate": "プロモーション内容",
    "regularRate": "標準価格",
    "signUpFor": "会員価格"
  },
  "membershipForm": {
    "address": "住所",
    "alreadyHaveAccount": "すでに登録済の方",
    "back": "戻る",
    "buildingName": "建物名・部屋番号",
    "changePassword": "パスワード再設定",
    "changePasswordResult": "パスワード再設定",
    "changePasswordResult02": "✓ お客様のパスワードの再設定が完了しました。",
    "changePasswordResult03": "こちらからログインしてください。",
    "changePasswordSecondary": "パスワードを入力してください。",
    "confirmDeletedResult": "退会処理が完了しました。",
    "confirmNewPassword": "新しいパスワード（確認用）",
    "confirmPassword": "パスワード確認",
    "confirmRegisterFail": "登録失敗",
    "confirmRegisterFail02": "お手数ですが、もう一度登録手続きをお願いいたします。",
    "confirmRegisterResult": "メールアドレス確認完了",
    "confirmRegisterResult02": "✓ 登録が完了しました",
    "confirmRegisterResult03": "滞在をお楽しみください",
    "createAccount2": "会員登録する",
    "createAccount3": "会員登録",
    "dob": "生年月日",
    "email": "メールアドレス",
    "emailError": "メールアドレスをご確認ください",
    "emailPromotionCheck": "施設からプロモーションメールを受信する",
    "english_error": "英語で入力ください",
    "locale_error": {
      "ja": "英語で入力ください",
      "zh_Hant": "英語で入力ください",
      "ko": "英語で入力ください"
    },
    "enterDetail": "メールアドレスとパスワードを入力してください",
    "first_name": "名",
    "firstNameLocales": {
      "ja": "名",
      "zh_Hant": "名(アルファベット)",
      "ko": "名(アルファベット)"
    },
    "first_name_kanji": "名",
    "first_name_kanji_placeholder": "太郎",
    "first_name_placeholder": "たろう",
    "firstNamePlaceHolderLocales": {
      "ja": "たろう",
      "zh_Hant": "Tarou",
      "ko": "Tarou"
    },
    "firstName": "名",
    "firstNameError": "名を入力してください",
    "firstNameKana": "めい（ひらがな）",
    "forgotPassword": "パスワードをお忘れの方",
    "forgotPassword02": "パスワード再設定",
    "forgotPasswordError": "ご入力いただいたメールアドレスの登録がありません。",
    "forgotPasswordResult": "パスワード再設定",
    "forgotPasswordResult02": "✓ パスワード再設定メールを送信しました。",
    "forgotPasswordResultSecondary": "メールの配信には時間がかかる場合があります。10分ほど経過してもメールが配信されない場合には、下記の再送信ボタンをクリックして、再設定メールを再送してください。",
    "forgotPasswordSecondary": "パスワードの再設定方法を送信いたします。登録しているメールアドレスを入力してください。なお、送信元アドレスは、{email}です。",
    "gender": "性別",
    "generalError": "申し訳ございません、処理中にエラーが発生しました。少し時間を空けてから、再度お試しください。",
    "guest_first_name": "めい（ひらがな）",
    "guest_first_name_kanji": "名（漢字）",
    "guest_last_name": "せい（ひらがな）",
    "guest_last_name_kanji": "姓（漢字）",
    "header": "会員登録",
    "hiragana_error": "ひらがなで入力してください。",
    "kanji_error": "漢字・ひらがな・カタカナで入力してください。",
    "last_name": "姓",
    "lastNameLocales": {
      "ja": "姓",
      "zh_Hant": "姓(アルファベット)",
      "ko": "姓(アルファベット)"
    },
    "last_name_kanji": "姓",
    "last_name_kanji_placeholder": "山田",
    "last_name_placeholder": "やまだ",
    "lastNamePlaceHolderLocales": {
      "ja": "やまだ",
      "zh_Hant": "Yamada",
      "ko": "Yamada"
    },
    "lastName": "姓",
    "lastNameError": "姓を入力してください",
    "lastNameKana": "せい（ひらがな）",
    "membershipId": "会員番号",
    "membershipProgram": "会員名称",
    "name": "名前",
    "nationality": "国籍",
    "newPassword": "新しいパスワード（英大文字・英小文字・数字それぞれを最低1文字ずつ含み、8文字以上にする必要があります。）",
    "noAccount": "会員登録がお済みではない方",
    "occupation": "ご職業",
    "or": "または",
    "orContinueBelow": "または以下をご記入ください。",
    "password": "パスワード",
    "passwordConfirmationError": "パスワードが一致しません。",
    "passwordError": "パスワードをご確認ください",
    "passwordSignUp": "パスワード（英大文字・英小文字・数字それぞれを最低1文字ずつ含み、8文字以上にする必要があります。）",
    "pleaseSelect": "会員名称を選択してください",
    "postCode": "郵便番号",
    "postCodeError": "アルファベットと数字のみ入力出来ます。",
    "prefecture": "都道府県",
    "notApplicable": "海外のため該当しない",
    "privacyPolicy": "プライバシーポリシー",
    "promotionsCheckbox": "emailでキャンペーンなどの情報を受け取る",
    "resend": "再送信",
    "resendConfirmationEmail": "会員登録確認メールが届かなかった場合",
    "resendConfirmationEmailError": "このメールアドレスは会員登録に利用されていません。",
    "resendConfirmationEmailTitle": "会員登録確認メール再送",
    "send": "送信",
    "setPassword": "設定",
    "setup": "会員登録",
    "setupResultSecondary01": "再度会員登録を行う場合、 {0} から再登録を行ってください。",
    "setupResultSecondary02": "ご登録いただいたメールアドレスの確認のためにメールを送付しました。\n現在は仮登録の状態なので、会員登録を完了するためにメールに記載のURLにアクセスしてください。\nその後ログイン可能となります。",
    "signIn": "ログイン",
    "signInHere": "ログイン",
    "signInTo": "{0}にログイン",
    "signUp": "会員登録",
    "signUpResult": "確認メールを送信しました",
    "signUpResult02": "仮登録が完了しました",
    "signUpResult02Secondary": "{n}の会員登録にお申し込みいただき、ありがとうございます。",
    "signUpResult02Secondary02": "ご登録いただいたメールアドレスの確認のためにメールを送付しました。\n現在は仮登録の状態なので、会員登録を完了するためにメールに記載のURLにアクセスしてください。\nその後ログイン可能となります。",
    "signUpResultSecondary": "{n}の会員登録にお申し込みいただき、ありがとうございます。",
    "signUpResultSecondary02": "ご登録いただいたメールアドレスの確認のためにメールを送付しました。",
    "signUpResultSecondary03": "内容をご確認の上、記載されているURLにアクセスしてください。",
    "signUpResultSecondary04": "メールアドレスの確認後に、会員登録が完了します。",
    "signUpSecondary": "会員登録はすぐに完了します。",
    "term": "{0} および {1} に同意します。",
    "termError": "利用規約に合意してください。",
    "termOfUse": "利用規約",
    "wifi": "WiFi無料",
    "yetReceived": "メールが届かない場合、{0}",
    "resendEmail": "再送します",
    "pleaseResetPassword": "このメールアドレスは本登録済みのため、確認メールの再送は必要ありません。\nパスワードがわかる方は、「{0}」にお進みください。\nパスワードがわからない方は、「{1}」より再設定ください。\n",
    "pleaseResetPasswordLink1": "会員ログイン",
    "pleaseResetPasswordLink2": "パスワードをお忘れの方"
  },
  "membersihp": {
    "target": "対象会員"
  },
  "myAccount": {
    "changeLoginEmail": "メールアドレス変更",
    "changeLoginEmailDescription": "メールアドレスを変更すると、新しいメールアドレスに確認メールが送信されます。メールに記載されているURLをクリックすると変更が完了します。メールアドレスを間違えた場合には、再変更すると、最後に変更したメールアドレスに確認メールが配信されます。",
    "changeLoginEmailPendingText": "新しいメールアドレスは確認中の状態です。更新時に配信されたメールに記載されているURLをクリックすると反映されます。",
    "changePassword": "パスワード再設定",
    "confirmLoginEmail": "新しいメールアドレス（確認中）",
    "edit": "編集",
    "emailLabel": "メールアドレス",
    "loginEmail": "メールアドレス",
    "loginInfo": "ログイン情報",
    "notRegistered": "登録済のカードはありません",
    "pageTitle": "アカウント",
    "password": "パスワード",
    "passwordLabel": "パスワード",
    "paymentInfo": "お支払い情報",
    "paymentOptions": "お支払い方法",
    "paymentOptionsDesc": "お支払いカード情報を保存すると、今後のサービスをさらに便利にご利用いただけます。\nクレジットカードに関するすべての情報は厳重に管理されます。",
    "pendingEmailText": "{n} メールアドレス確認中",
    "personalInfo": "個人情報",
    "point": "ポイント",
    "removeAccount": "退会",
    "removeAccountConfirmationText": "本当によろしいですか？",
    "removeAccountReason01": "もう利用しないため",
    "removeAccountReason02": "宿泊費が高いため",
    "removeAccountReason03": "会員特典に魅力がないため",
    "removeAccountReasonInput": "理由を入力してください",
    "removeAccountReasonOthers": "その他",
    "removeAccountSecondaryText": "退会すると全ての会員特典が無効となります。",
    "removeAccountSecondaryText02": "また予約情報も表示できなくなります。",
    "removeCreditCard": "カードを削除する",
    "removeCreditCardConfirm": "登録されているカードを削除します。よろしいですか？",
    "resendEmail": "確認メールを再送信",
    "resendEmailSuccess": "確認メールを再送信しました。",
    "yourCreditCards": "登録カード",
    "membershipId": "会員ID",
    "myQRCode": "QRコード",
    "promotion": "プロモーション",
    "historyStatus": {
      "expired": "期限切れポイント",
      "future": "獲得予定ポイント",
      "spent": "利用ポイント",
      "gained": "獲得ポイント",
      "refunded": "払い戻しポイント"
    },
    "value": "値",
    "badCards": "システム変更のため、このカードは新規のご予約にはご利用いただけません。"
  },
  "myProfile": {
    "cancel": "予約をキャンセルする",
    "cancelled": "キャンセル済",
    "change": "変更",
    "checkIn": "チェックイン:",
    "checkOut": "チェックアウト:",
    "confirmationNo": "予約番号",
    "multiRoom": "複数の部屋タイプ",
    "myReservations": "予約一覧",
    "noResultButtonText": "空室を検索する",
    "noResultText": "予約はまだありません。",
    "pageTitle": "アカウント情報",
    "viewDetails": "詳細確認",
    "viewFlightDetails": "航空券付き予約の詳細確認"
  },
  "organization": {
    "enterDetail": "お持ちのアカウントをID・パスワードに入力してください",
    "signIn": "法人ログイン"
  },
  "ota": {
    "changeLoginEmailPendingText": "新しいメールアドレスは確認中の状態です。更新時に配信されたメールに記載されているURLをクリックすると反映されます。",
    "name": {
      "agoda": "Agoda",
      "booking_com": "Booking com",
      "expedia": "Expedia",
      "jalan": "じゃらん",
      "rakuten_travel": "楽天トラベル",
      "rakutenTravel": "楽天トラベル"
    },
    "priceNotAvailable": "利用できません"
  },
  "paymentMethod": {
    "paypalCheckbox1": "クレジットカードの発行会社が3Dセキュアに対応していない場合には、利用できません。",
    "paypalCheckbox2": "当社がお客様から収集した以下の個人情報等は、カード発行会社が行う不正利用検知・防止のために、お客様が利用されているカード発行会社へ提供させていただきます。",
    "paypalCheckbox3": "氏名、電話番号、emailアドレス、インターネット利用環境に関する情報等",
    "paypalCheckbox4": "お客様が利用されているカード発行会社が外国にある場合、これらの情報は当該発行会社が所属する国に移転される場合があります。",
    "paypalCheckbox5": "お客様が未成年の場合、親権者または後見人の承諾を得た上で、本サービスを利用するものとします。",
    "credit_card": "事前決済",
    "deferred_payment": "後払い",
    "on_site": "現地決済",
    "on_site_credit_card_required": "現地決済",
    "type": "支払種別",
    "twd_credit_card": "クレジットカードでの全額支払い",
    "twd_credit_card_deposit": "クレジットカードでのデポジット支払い",
    "bank_transfer": "銀行振込"
  },
  "pointHistory": {
    "cancellation": "キャンセル",
    "dateColumn": "日付",
    "descriptionColumn": "内容",
    "failToLoadErrorMessage": "ポイント履歴を読み込み出来ませんでした。",
    "noData": "ポイント履歴はありません。",
    "pointExpirationColumn": "有効期限",
    "pointHistory": "ポイント履歴",
    "pointsColumn": "ポイント数",
    "pointUse": "ポイント利用",
    "stay": "宿泊",
    "viewMore": "追加で読み込む",
    "exchangeDigico": "ポイント交換",
    "exchangeDigicoDesc": "デジコポイントに交換したいポイント数を入力してください。デジコポイントは、Amazonギフト券、App Store & iTunesコード、Google Playギフトコードなど、他のポイントプログラムに交換できます。 このプロセスを元に戻すことはできず、デジコポイントは交換後180日間のみ有効です。 このサービスは日本国内でのみご利用いただけます。 交換後のデジコポイントについての質問にはお答えできません。 デジコポイントの詳細については、{0}を参照してください。",
    "exchangeDigicoLink": "こちら",
    "exchangeDigicoLog": "デジコポイント交換",
    "exchangeAvaliablePoints": "利用可能な合計ポイント",
    "exchangeBtn": "交換",
    "exchangeHistory": "ポイント交換",
    "exchangedAmount": "交換金額",
    "exchangedDigicoCode": "コード",
    "exchangeConfirm": "このプロセスを元に戻すことはできません。 ポイント交換を続行してもよろしいですか？",
    "exchangeConfirmBtn": "続行する",
    "digicoPointUrl": "デジコポイント交換URL：",
    "invalidAmount": "有効なポイント額を入力してください。",
    "totalBalance": "合計",
    "currentPoints": "利用可能ポイント",
    "futurePoints": "獲得予定ポイント"
  },
  "pointSpending": {
    "balance": "利用可能ポイント",
    "errors": {
      "incorrectAmount": "ポイントは{n}ポイント毎に利用可能です",
      "moreThanPrice": "宿泊価格以上のポイントは利用できません。",
      "upToBalance": "ポイント残高以上のポイントは指定できません。",
      "pointUsageError": "すべてのお支払いにポイントをご利用になる場合、クレジットカードはご利用できません。"
    },
    "minimumAmount": "ポイント利用は{0}ポイント以上からになります。",
    "points": "ポイント",
    "saveForLater": "今回はポイントを利用しない",
    "updateRule": "既存の予約で使用されたポイントは、使用することができません。既存の予約に使用されたポイントは、予約が更新された後に返還されます。",
    "useAll": "持っているポイントを全て使う",
    "useAmount": "利用ポイント数を指定する"
  },
  "progressBar": {
    "confirmationSubtitle": "ご予約を承りました",
    "confirmationTitle": "予約確定",
    "guestSubtitle": "お客様情報をご記入ください",
    "guestTitle": "お客様情報",
    "paymentSubtitle": "お支払い方法をお選びください",
    "paymentTitle": "支払い"
  },
  "reservation": {
    "cancelled": "キャンセル済",
    "completed": "宿泊済",
    "upcoming": "予約中"
  },
  "reservationAction": {
    "applyGOTO": "クーポンコードを適用する",
    "bookingCancel": "予約をキャンセルする",
    "bookingUpdate": "お客様情報を更新する",
    "corporateSignInRequired": "予約を更新するためには、法人ログインが必要です。",
    "differentFacilityWarning": "予約を更新するためには、予約した施設にてログインしてください。",
    "everythingCorrectSubtitle": "以下より、本予約のお客様情報の更新・キャンセルを行えます。",
    "everythingCorrectTitle": "予約管理",
    "invoiceDownload": "このページを印刷する",
    "madeMistakeHelp": "次回のご利用をお待ちしております。",
    "madeMistakeTitle": "ご予約はキャンセルされました。",
    "memberSignInRequired": "予約を更新するためには、会員ログインが必要です。",
    "pleaseCancelAll": "すべての部屋をキャンセルする場合には、予約をキャンセルしてください",
    "payByCreditCard": "事前カード決済",
    "reductionOfNights": "減泊",
    "reductionOfRooms": "減室",
    "selectRoomsToCancel": "キャンセルする部屋を選択してください",
    "signOutRequired": "予約を更新するためには、ログアウトが必要です。",
    "updateExpired": "本予約は変更期限を過ぎたため予約変更が出来ません。",
    "updateItinerary": "予約変更",
    "differentAccountWarning": "正しいアカウントでサインインして、予約を更新してください",
    "differentOrgWarning": "正しい法人組織でサインインして、予約を更新してください",
    "coupon": {
      "signOutRequired": "サインアウトしてクーポンを適用してください。",
      "memberSignInRequired": "クーポンの適用には会員ログインが必要です。",
      "corporateSignInRequired": "クーポンを適用するには、法人ログインが必要です。",
      "differentFacilityWarning": "クーポンを適用するには、予約した施設からログインしてください。",
      "differentAccountWarning": "クーポンを適用するには、正しいアカウントでサインインしてください。",
      "differentOrgWarning": "クーポンを適用するには、正しい法人組織でサインインしてください。"
    }
  },
  "reservationCancellation": {
    "cancel": "ご予約のキャンセル",
    "cancellationConfirm": "ご予約のキャンセルを行いますか？",
    "cancellationFee": "キャンセル料",
    "cancellationOnDay": "当日のキャンセルはオンラインではできません。",
    "cancellationPolicy": "キャンセルポリシー",
    "cancellationTitle": "予約をキャンセルする",
    "contactByChatPhone": "お手数ですが、お電話でご連絡ください。",
    "contactByPhone": "お手数ですが、お電話でご連絡ください。",
    "contactPhone": "電話番号 {0}",
    "keep": "予約したままにする",
    "nonRefundable": "払い戻し不可",
    "reason": "キャンセル理由をお選びください。",
    "reasonDifferentHotel": "他のホテルを予約した",
    "reasonNbTrvellers": "人数が変わった",
    "reasonOther": "その他",
    "reasonOtherHelp": "その他をお選びの方は詳細をお知らせください",
    "reasonRoomCheaper": "他に安い部屋が見つかった",
    "reasonTripCancelled": "旅行がキャンセルになった",
    "roomNbCancelFee": "{0}部屋目 キャンセル料",
    "totalCancelFee": "キャンセル料 合計"
  },
  "reservationConfirmation": {
    "cancellationFreeUntil": "{0}まではキャンセル料がかかりません。",
    "cannotChangePlan": "本予約に含まれているプランは変更出来ません。",
    "confirmationEmail": "{0}に確認メールを送信いたしました",
    "extra": {
      "answer": "回答",
      "dateTime": "利用日時",
      "extrasPrice": "オプション",
      "items": "選択数",
      "notes": "ご注意",
      "price": "価格",
      "priceIncludeTax": "税込価格",
      "question": "質問",
      "roomPrice": "合計宿泊金額"
    },
    "extrasSubtotal": "オプションの小計",
    "nonRefundableReminder": "この予約は返金不可です。キャンセルしても返金されません。",
    "originalReservationPlans": "本予約で選択されているプラン",
    "reservationDetail": "ご予約内容",
    "selectNewItinerary": "変更後のチェックイン/アウト日、人数を選択し、変更可能な部屋タイプ・プランを検索ください。",
    "updateBooking": "予約変更"
  },
  "reservationDetail": {
    "adult": "{n}名様",
    "accommodationTax": "宿泊税",
    "checkIn": "チェックイン日",
    "checkOut": "チェックアウト日",
    "child": "{n}名様",
    "dayUse": "日帰り",
    "discount": "値引き",
    "discountedPrice": "ポイント値引き",
    "guest": "{n}名様",
    "maxGuests": "最大定員",
    "night": "{n}泊",
    "nights": "宿泊日数",
    "numberOfGuest": "ご利用部屋数",
    "numberOfNights": "宿泊日数",
    "originalPrice": "お支払い金額",
    "pointDiscount": "ポイント値引き",
    "pointInstruction": "ポイントはチェックアウトの3日後に加算されます。",
    "pointReward": "この予約で{0}ポイントが加算されます",
    "priceBreakDown": "料金詳細",
    "reservationNumber": "予約番号",
    "roomDetails": "お部屋の詳細",
    "roomNb": "{0}部屋目",
    "roomPlan": "プラン名",
    "roomRate": "客室料金",
    "roomType": "部屋タイプ",
    "searchNecessary": "この予約番号は予約の照会・キャンセル時、あるいはホテルへの問合せ時に必須となります。",
    "serviceFee": "サービス料",
    "subTotal": "小計",
    "subTotalWithoutTax": "小計（税抜）",
    "tax": "消費税",
    "taxIncluded": "税込",
    "total": "お支払い金額（税込）",
    "depositAmount": "デポジット（{0}％）",
    "remainAmount": "残りのお支払い金額",
    "withTax": "税込",
    "depositNecessary": "予約確認を完了するには、オンラインシステムを介して{0}％のデポジットを支払う必要があります。"
  },
  "reservationPayment": {
    "creditCardPayment": "事前支払い",
    "onSitePayment": "チェックイン時に支払い（前払い不要）",
    "paymentMethod": "支払い方法",
    "pendingPage": {
      "launchButton": "3Dセキュア",
      "text01": "ボタンをクリックすると3Dセキュアのパスワード入力画面に移動します。",
      "text02": "15分以内にパスワード入力が完了しない場合には、予約処理が中止されます。",
      "text03": "予約はパスワードを入力するまで確定されないので、空室が無くなる場合がございます。",
      "text04": "クレジットカード決済はtriplaが代行するので、3Dセキュアの店舗名には「tripla」と表示されます。",
      "timeOutError01": "タイムアウトエラーが発生しました。",
      "timeOutError02": "決済処理は行われておりません。",
      "authError01": "決済処理に失敗しました。",
      "error01": "予約処理中にエラーが発生しました。",
      "error02": "決済処理は行われておりません。",
      "error03": "「戻る」ボタンをクリックし、検索結果画面から予約をやり直してください。"
    },
    "planError": "現在、このプランでは、選択したお支払い方法はご利用いただけません。再度お試しください",
    "selectCreditCards": "クレジットカードを選択してください"
  },
  "reservationReceipt": {
    "customerName": "宛名",
    "deferredWithoutDownload": "後払いのため、領収書は発行されません。",
    "download": "領収書ダウンロード",
    "downloadOnCheckout": "領収書はチェックアウト日以降にダウンロードできます。",
    "onSite": "現地支払いの場合は、領収書はホテルのフロントデスクでの発行となります。"
  },
  "searchBar": {
    "addRoom": "部屋を追加",
    "adult": "大人{n}名様",
    "adults": "大人",
    "age": "年齢",
    "agree": "同意する",
    "bed": "布団あり",
    "checkIn": "チェックイン",
    "checkInAndOut": "チェックイン - チェックアウト",
    "checkOut": "チェックアウト",
    "child": "子供{n}名様",
    "childN": "子供 {n}",
    "children": "子供",
    "childrenAgeAtCheckout": "チェックアウト時の子どもの年齢",
    "childrenAgeInfant": "幼児 {from}-{to}才",
    "childrenAgePrimary": {
      "primary": "小学生",
      "primaryBottom": "小学生（低学年）",
      "primaryTop": "小学生（高学年）"
    },
    "childrenAges": "子供の年齢",
    "childrenAgeSharedBed": "年齢 {from}-{to}",
    "childrenMealBedding": {
      "meal_no": "食事・布団なし",
      "meal_no_bedding": "布団あり",
      "meal_same_as_adult_bedding": "食事・布団あり",
      "meal_yes": "食事あり",
      "meal_yes_bedding": "食事・布団あり"
    },
    "cookieConsent": "当サイトではサイトの利便性の向上を目的にクッキーを使用します。当サイトの閲覧を続けることで、クッキーの取得に同意したものとみなします。詳細は{0}をご覧ください。",
    "privacyPolicy": "プライバシーポリシー",
    "perRoomGuests": "一部屋あたりのご利用人数",
    "dates": "ご宿泊日",
    "dayUse": "日帰りプランを検索",
    "defaultArea": "全ての地域",
    "edit": "修正",
    "filter": "絞り込み",
    "guests": "ご利用人数",
    "hotel": "ホテル",
    "maxChildrenWarning": "子供の定員は大人1名様つき{n}名です",
    "pleaseSelectHotel": "ホテルを選択してください",
    "room": "{n}部屋",
    "rooms": "部屋数",
    "search": "検索",
    "showOnlyAvailable": "予約可能なもののみ表示",
    "sort": "並び替え",
    "sortOption": {
      "price_high_to_low": "価格の高い順",
      "price_low_to_high": "価格の安い順",
      "recommended": "おすすめ順"
    },
    "to": "から",
    "undated": "日付未定",
    "nights": "宿泊日数",
    "yearOld": "{n} 歳",
    "undatedWarning": "部屋毎の人数が異なる場合には、日付未定検索はご利用いただけません"
  },
  "searchReservation": {
    "enterDetail": "予約番号をお持ちのお客様 予約番号、Eメールアドレスを入力してください。",
    "enterReservationNumber": "予約番号を入力",
    "manageBooking": "宿泊予約確認・キャンセル",
    "searchFailed": "メールアドレスや予約番号が入力されていません。ご確認のうえ、もう一度やり直してください。"
  },
  "searchResultByPlan": {
    "hide": "閉じる",
    "planContent": "プラン内容",
    "plans": "プラン",
    "rooms": "部屋",
    "showPlan": "プラン詳細を表示",
    "moreDetail": "続きを読む"
  },
  "snsLogin": {
    "loginWith": "{0}でログイン",
    "enterPassword": "続行するには、パスワードを入力してください。",
    "existingPrompt": "既存のアカウントをお持ちのようです。\n既存のアカウントと{sns}のアカウントを連携しますか？{sns}とメール・パスワードの両方でログインできるようになります。",
    "signUpDescription": "{sns}アカウントからサインアップしていただきありがとうございます。アカウントの登録を完了するには、続けて情報をご入力ください。"
  },
  "voucher": {
    "cancel": "変更をキャンセル",
    "confirm": "確定する",
    "number": "チケット番号",
    "purchseComplete": "購入完了",
    "selectStay": "チェックイン日を選択ください",
    "stillVoucher": "こちらは宿泊チケットです。まだ正式な予約として宿泊日程は指定されていません。",
    "ThankPurchase": "チケットのご購入ありがとうございます",
    "update": "変更を確定",
    "updateItinerary": "予約を変更する",
    "updateItineraryDesc": "新しい宿泊日程を指定してください。「変更確定」ボタンをクリックすると、変更が確定します。",
    "usingVoucher": "チケットを利用する",
    "valid": "このチケットは有効です",
    "voucherDesc": "本チケットを利用するためには宿泊日程を指定してください。\n「予約する」ボタンをクリックすると予約が確定します。",
    "voucherDetails": "チケットの詳細",
    "voucherNumber": "チケット番号"
  },
  "triplaPay": {
    "isPaid": "この支払いは正常に完了しました",
    "isAlreadyPaid": "Already paid",
    "isFailed": "お支払いできませんでした。",
    "isCompleted": "この支払いは正常に完了しました",
    "isRefunded": "お支払いは返金されました",
    "refundedAt": "返金日",
    "paidAt": "支払期日",
    "isCancelled": "お支払いはキャンセルされました。",
    "total": "お支払い金額",
    "pleaseReload": "1時間以内に完了しなかったので、「更新」ボタンをクリックして、再読み込みしてください。",
    "reload": "更新",
    "subject": "支払い対象",
    "amountIsChanged": "お支払い金額が変更されたので、「更新」ボタンをクリックして、再読み込みしてください。",
    "terms": "本決済システムはtripla(株)により提供されており、お客様の個人情報はtripla(株)と共有されることを理解の上で、tripla{0}、{1}、および、{2}に同意します。",
    "paypalTerms": "なお、カード決済にはPayPal を利用しており、カードのご利用明細には、PayPalと記載されます。",
    "temsOfUse": "利用規約",
    "privacyPolicy": "個人情報の取扱い",
    "gdprPolicy": "GDPRポリシー",
    "pleaseScan": "QRコードをスキャンしてください"
  },
  "triplaPayIssues": {
    "INVALID_PARAMETER_SYNTAX": "入力内容をご確認ください。",
    "INVALID_EXPIRATION_YEAR": "有効期限をご確認ください。",
    "Invalid_card_number": "カード番号をご確認ください。",
    "Others": "入力内容をご確認ください。"
  }
}